var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "StepLayout",
    {
      attrs: { "scroll-init-time": _vm.scrollInitTime, "need-nav": true },
      scopedSlots: _vm._u([
        {
          key: "rightBox",
          fn: function (scope) {
            return _c("div", { staticClass: "rightNavGroup" }, [
              _c(
                "div",
                { staticClass: "navBox" },
                _vm._l(_vm.navList, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "nItem",
                      class: { active: index === scope.navActive },
                      on: {
                        click: function ($event) {
                          return scope.jump(index)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.txt))]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "m-actions" },
                [
                  _vm.mode === "edit"
                    ? [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: { click: _vm.onSaveDraft },
                          },
                          [_vm._v(_vm._s(_vm.$t("common.saveDraft")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "small" },
                            on: { click: _vm.onDraftAndGo },
                          },
                          [_vm._v(_vm._s(_vm.$t("common.nextStep")))]
                        ),
                      ]
                    : [
                        _c(
                          "el-button",
                          {
                            key: _vm.mode,
                            attrs: {
                              type: "primary",
                              size: "small",
                              disabled: _vm.mode === "error",
                            },
                            on: { click: _vm.onNext },
                          },
                          [_vm._v(_vm._s(_vm.$t("common.nextStep")))]
                        ),
                      ],
                ],
                2
              ),
            ])
          },
        },
      ]),
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          staticClass: "formGroup",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            size: "small",
            inline: "",
            "label-position": "top",
          },
        },
        [
          _c(
            "InfoItem",
            {
              class: "container-item _scroll_item",
              attrs: {
                title: "1." + _vm.$t("storeVisitReport.common.basicInfo"),
                "default-open": false,
              },
              on: { slider: _vm.onScollChange },
            },
            [
              _c(
                "div",
                { staticClass: "formStyle1" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.basic.customerNumber"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.info.storeInfo.rtlSapId,
                          disabled: "",
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.info.storeInfo,
                              "rtlSapId",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      key: "rtlFullName_" + (_vm.isQzkh ? "qzkh" : ""),
                      attrs: {
                        prop: "storeInfo.rtlFullName",
                        rules: _vm.isQzkh
                          ? _vm.rules.validateIpt.concat(_vm.rules.iptEmpty)
                          : [],
                        label: _vm.$t("storeVisitReport.basic.storeName"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.form.storeInfo.rtlFullName,
                          tipable: "",
                          maxlength: 50,
                          disabled: !_vm.isQzkh,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "rtlFullName",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "storeVisitReport.basic.retailStoreRTMCategory"
                        ),
                      },
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          val: _vm.info.storeInfo.rtlRtmCategory,
                          options: _vm.optConfig.rtmOptions,
                          disabled: "",
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.info.storeInfo,
                              "rtlRtmCategory",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "storeVisitReport.basic.retailStoreCategory"
                        ),
                      },
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          val: _vm.info.storeInfo.retailerType,
                          options: _vm.optConfig.storeCategoryOptions,
                          disabled: "",
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.info.storeInfo,
                              "retailerType",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "storeVisitReport.basic.retailStoreCategoryDesc"
                        ),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.formatRType(
                            _vm.info.storeInfo.retailerTypeDescription
                          ),
                          disabled: "",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "storeVisitReport.more.customerCreationDate"
                        ),
                      },
                    },
                    [
                      _c("FormDatePicker", {
                        attrs: {
                          val: _vm.info.storeInfo.registrationDate,
                          disabled: "",
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.info.storeInfo,
                              "registrationDate",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.canEdit && _vm.isQzkh
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "storeInfo.PCD",
                            rules: _vm.rules.chooseEmpty,
                            label: _vm.$t(
                              "storeVisitReport.basic.provinceCityDistrict"
                            ),
                          },
                        },
                        [
                          _c("FormCascader", {
                            attrs: {
                              "target-form": _vm.form.storeInfo,
                              "key-list": [
                                "rtlRegion",
                                "rtlRegionCode",
                                "rtlCity",
                                "rtlCityCode",
                                "rtlDistrict",
                                "rtlDistrictCode",
                              ],
                              mode: _vm.mode,
                            },
                          }),
                        ],
                        1
                      )
                    : [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("storeVisitReport.basic.province"),
                            },
                          },
                          [
                            _c("FormInput", {
                              attrs: {
                                val: _vm.form.storeInfo.rtlRegion,
                                disabled: "",
                              },
                              on: {
                                "update:val": function ($event) {
                                  return _vm.$set(
                                    _vm.form.storeInfo,
                                    "rtlRegion",
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("storeVisitReport.basic.city"),
                            },
                          },
                          [
                            _c("FormInput", {
                              attrs: {
                                val: _vm.form.storeInfo.rtlCity,
                                disabled: "",
                              },
                              on: {
                                "update:val": function ($event) {
                                  return _vm.$set(
                                    _vm.form.storeInfo,
                                    "rtlCity",
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("storeVisitReport.basic.area"),
                            },
                          },
                          [
                            _c("FormInput", {
                              attrs: {
                                val: _vm.form.storeInfo.rtlDistrict,
                                disabled: "",
                              },
                              on: {
                                "update:val": function ($event) {
                                  return _vm.$set(
                                    _vm.form.storeInfo,
                                    "rtlDistrict",
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      key: "rtlAddress_" + (_vm.isQzkh ? "qzkh" : ""),
                      attrs: {
                        prop: "storeInfo.rtlAddress",
                        rules: _vm.isQzkh
                          ? _vm.rules.validateIpt.concat(_vm.rules.iptEmpty)
                          : [],
                        label: _vm.$t("storeVisitReport.basic.address"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.form.storeInfo.rtlAddress,
                          tipable: "",
                          maxlength: 100,
                          disabled: !_vm.isQzkh,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "rtlAddress",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      key: "contactsNameOne_" + (_vm.isQzkh ? "qzkh" : ""),
                      attrs: {
                        prop: "storeInfo.contactsNameOne",
                        rules: _vm.isQzkh
                          ? _vm.rules.validateIpt.concat(_vm.rules.iptEmpty)
                          : [],
                        label: _vm.$t("storeVisitReport.basic.contact1"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.form.storeInfo.contactsNameOne,
                          maxlength: 10,
                          disabled: !_vm.isQzkh,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "contactsNameOne",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      key: "contactsMobileOne_" + (_vm.isQzkh ? "qzkh" : ""),
                      attrs: {
                        prop: "storeInfo.contactsMobileOne",
                        rules: _vm.isQzkh
                          ? _vm.rules.phoneEmpty.concat(_vm.rules.validatePhone)
                          : [],
                        label: _vm.$t("storeVisitReport.basic.cellPhone1"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.form.storeInfo.contactsMobileOne,
                          disabled: !_vm.isQzkh,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "contactsMobileOne",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("storeVisitReport.more.empNo") } },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.info.storeInfo.empNo, disabled: "" },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.info.storeInfo, "empNo", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("storeVisitReport.more.empName") },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.info.storeInfo.empName,
                          disabled: "",
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.info.storeInfo,
                              "empName",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.more.serviceProvider"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.info.storeInfo.spFullName,
                          disabled: "",
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.info.storeInfo,
                              "spFullName",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "InfoItem",
            {
              class: "container-item _scroll_item",
              attrs: {
                title: "2." + _vm.$t("storeVisitReport.common.moreInfo"),
                "default-open": false,
              },
              on: { slider: _vm.onScollChange },
            },
            [
              _c(
                "div",
                { staticClass: "formStyle1" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.more.contact2"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.form.storeInfo.contactsNameTwo,
                          maxlength: 10,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "contactsNameTwo",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "storeInfo.contactsMobileTwo",
                        rules: _vm.rules.validatePhone,
                        label: _vm.$t("storeVisitReport.more.cellPhone2"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.form.storeInfo.contactsMobileTwo,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "contactsMobileTwo",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.more.contact3"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.form.storeInfo.contactsNameThree,
                          maxlength: 10,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "contactsNameThree",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "storeInfo.contactsMobileThree",
                        rules: _vm.rules.validatePhone,
                        label: _vm.$t("storeVisitReport.more.cellPhone3"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.form.storeInfo.contactsMobileThree,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "contactsMobileThree",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.more.category1"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.form.storeInfo.remarkOne,
                          disabled: "",
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "remarkOne",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.more.category2"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.form.storeInfo.remarkTwo,
                          disabled: "",
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "remarkTwo",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("storeVisitReport.more.category3"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.form.storeInfo.remarkThree,
                          disabled: "",
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "remarkThree",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "InfoItem",
            {
              class: "container-item _scroll_item",
              attrs: {
                title: "3." + _vm.$t("storeVisitReport.common.RSSAS"),
                "default-open": false,
              },
              on: { slider: _vm.onScollChange },
            },
            [
              _c(
                "div",
                { staticClass: "formStyle1" },
                [
                  _c(
                    "el-form-item",
                    {
                      key:
                        "customerTireBizYear_" +
                        (_vm.isBailianFlag ? "by" : ""),
                      attrs: {
                        label: _vm.$t("storeVisitReport.RSSAS.carTRHistory"),
                        prop: "storeInfo.customerTireBizYear",
                        rules: _vm.isBailianFlag ? _vm.rules.iptEmpty : null,
                      },
                    },
                    [
                      _c("FormInputNumber", {
                        attrs: {
                          val: _vm.form.storeInfo.customerTireBizYear,
                          maxlength: 4,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "customerTireBizYear",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      key: "customerTireSob_" + (_vm.isBailianFlag ? "by" : ""),
                      attrs: {
                        label: _vm.$t("storeVisitReport.RSSAS.carTAForTotal"),
                        prop: "storeInfo.customerTireSob",
                        rules: _vm.isBailianFlag ? _vm.rules.iptEmpty : null,
                      },
                    },
                    [
                      _c(
                        "FormInputNumber",
                        {
                          attrs: {
                            val: _vm.form.storeInfo.customerTireSob,
                            max: 100,
                            step: 0.01,
                            mode: _vm.mode,
                          },
                          on: {
                            "update:val": function ($event) {
                              return _vm.$set(
                                _vm.form.storeInfo,
                                "customerTireSob",
                                $event
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "append" }, slot: "append" },
                            [_vm._v("%")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      key:
                        "monthTireSalesAvg_" + (_vm.isBailianFlag ? "by" : ""),
                      attrs: {
                        label: _vm.$t("storeVisitReport.RSSAS.AvMSalesOfTires"),
                        prop: "storeInfo.monthTireSalesAvg",
                        rules: _vm.rules.iptEmpty,
                      },
                    },
                    [
                      _c("FormInputNumber", {
                        attrs: {
                          val: _vm.form.storeInfo.monthTireSalesAvg,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "monthTireSalesAvg",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      key: "storeStructure_" + (_vm.isBailianFlag ? "by" : ""),
                      attrs: {
                        label: _vm.$t("storeVisitReport.RSSAS.RSS"),
                        prop: "storeInfo.storeStructure",
                        rules: _vm.isBailianFlag ? _vm.rules.chooseEmpty : null,
                      },
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          val: _vm.form.storeInfo.storeStructure,
                          options: _vm.optConfig.storeStructureOptions,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "storeStructure",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      key: "staff_" + (_vm.isBailianFlag ? "by" : ""),
                      attrs: {
                        label: _vm.$t("storeVisitReport.RSSAS.employeeCount"),
                        prop: "storeInfo.staff",
                        rules: _vm.isBailianFlag ? _vm.rules.iptEmpty : null,
                      },
                    },
                    [
                      _c("FormInputNumber", {
                        attrs: {
                          val: _vm.form.storeInfo.staff,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.form.storeInfo, "staff", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      key: "retailShare_" + (_vm.isBailianFlag ? "by" : ""),
                      attrs: {
                        label: _vm.$t("storeVisitReport.RSSAS.retailShare"),
                        prop: "storeInfo.retailShare",
                        rules: _vm.rules.iptEmpty,
                      },
                    },
                    [
                      _c(
                        "FormInputNumber",
                        {
                          attrs: {
                            val: _vm.form.storeInfo.retailShare,
                            max: 100,
                            step: 0.01,
                            mode: _vm.mode,
                          },
                          on: {
                            "update:val": function ($event) {
                              return _vm.$set(
                                _vm.form.storeInfo,
                                "retailShare",
                                $event
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "append" }, slot: "append" },
                            [_vm._v("%")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      key: "maxSalesBrand_" + (_vm.isBailianFlag ? "by" : ""),
                      attrs: {
                        label: _vm.$t("storeVisitReport.RSSAS.maxSalesBrand"),
                        prop: "storeInfo.maxSalesBrand",
                        rules: _vm.rules.iptEmpty,
                      },
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          val: _vm.form.storeInfo.maxSalesBrand,
                          options: _vm.optConfig.ssbtypeOptions,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "maxSalesBrand",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      key: "maxSalesQty_" + (_vm.isBailianFlag ? "by" : ""),
                      attrs: {
                        label: _vm.$t("storeVisitReport.RSSAS.maxSalesQty"),
                        prop: "storeInfo.maxSalesQty",
                        rules: _vm.rules.iptEmpty,
                      },
                    },
                    [
                      _c("FormInputNumber", {
                        attrs: {
                          max: 9999999,
                          val: _vm.form.storeInfo.maxSalesQty,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "maxSalesQty",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      key: "gySalesQty_" + (_vm.isBailianFlag ? "by" : ""),
                      attrs: {
                        label: _vm.$t("storeVisitReport.RSSAS.gySalesQty"),
                        prop: "storeInfo.gySalesQty",
                        rules: _vm.rules.iptEmpty,
                      },
                    },
                    [
                      _c("FormInputNumber", {
                        attrs: {
                          max: 9999999,
                          val: _vm.form.storeInfo.gySalesQty,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "gySalesQty",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "InfoItem",
            {
              class: "container-item _scroll_item",
              attrs: {
                title: "4." + _vm.$t("storeVisitReport.common.storeSInfo"),
                "default-open": false,
              },
              on: { slider: _vm.onScollChange },
            },
            [
              _c(
                "div",
                { staticClass: "formStyle1" },
                [
                  _c(
                    "el-form-item",
                    {
                      key: "signBoardBrand_" + (_vm.isBailianFlag ? "by" : ""),
                      attrs: {
                        label: _vm.$t(
                          "storeVisitReport.storeSInfo.shopSignBrand"
                        ),
                        prop: "storeInfo.signBoardBrand",
                        rules: _vm.rules.chooseEmpty,
                      },
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          val: _vm.form.storeInfo.signBoardBrand,
                          options: _vm.optConfig.ssbtypeOptions,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "signBoardBrand",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      key:
                        "installationDate_" + (_vm.isBailianFlag ? "by" : ""),
                      attrs: {
                        label: _vm.$t(
                          "storeVisitReport.storeSInfo.installationDate"
                        ),
                        prop: "storeInfo.installationDate",
                        rules: _vm.isBailianFlag ? _vm.rules.iptEmpty : null,
                      },
                    },
                    [
                      _c("FormDatePicker", {
                        attrs: {
                          val: _vm.form.storeInfo.installationDate,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "installationDate",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      key: "dueTime_" + (_vm.isBailianFlag ? "by" : ""),
                      attrs: {
                        label: _vm.$t("storeVisitReport.storeSInfo.expiryDate"),
                        prop: "storeInfo.dueTime",
                        rules: _vm.isBailianFlag ? _vm.rules.iptEmpty : null,
                      },
                    },
                    [
                      _c("FormDatePicker", {
                        attrs: {
                          val: _vm.form.storeInfo.dueTime,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "dueTime",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      key: "otherBrand_" + (_vm.isBailianFlag ? "by" : ""),
                      attrs: {
                        label: _vm.$t(
                          "storeVisitReport.storeSInfo.otherBrands"
                        ),
                        prop: "storeInfo.otherBrand",
                        rules: _vm.isBailianFlag ? _vm.rules.iptEmpty : null,
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.form.storeInfo.otherBrand,
                          maxlength: 10,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "otherBrand",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "formStyle1" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "storeVisitReport.storeSInfo.storefrontPic"
                        ),
                      },
                    },
                    [
                      _c("FormUploadImg", {
                        attrs: {
                          "file-url": _vm.form.storeInfo.photo1,
                          "upload-params": _vm.uploadParams,
                          "footer-text": _vm.photo1HistoryTime,
                          mode: "view",
                        },
                        on: {
                          "update:fileUrl": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "photo1",
                              $event
                            )
                          },
                          "update:file-url": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "photo1",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      key: "photo2_" + (_vm.isBailianFlag ? "by" : ""),
                      attrs: {
                        label: _vm.$t(
                          "storeVisitReport.storeSInfo.displayPic1"
                        ),
                        prop: "storeInfo.photo2",
                        rules: _vm.isBailianFlag ? _vm.rules.uploadEmpty : null,
                      },
                    },
                    [
                      _c("FormUploadImg", {
                        attrs: {
                          "file-url": _vm.form.storeInfo.photo2,
                          "upload-params": _vm.uploadParams,
                          "footer-text": _vm.photo2HistoryTime,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:fileUrl": function (v) {
                            return _vm.updateFormValue(
                              v,
                              "photo2",
                              _vm.form.storeInfo
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      key: "photo3_" + (_vm.isBailianFlag ? "by" : ""),
                      attrs: {
                        label: _vm.$t(
                          "storeVisitReport.storeSInfo.displayPic2"
                        ),
                        prop: "storeInfo.photo3",
                        rules: _vm.isBailianFlag ? _vm.rules.uploadEmpty : null,
                      },
                    },
                    [
                      _c("FormUploadImg", {
                        attrs: {
                          "file-url": _vm.form.storeInfo.photo3,
                          "upload-params": _vm.uploadParams,
                          "footer-text": _vm.photo3HistoryTime,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:fileUrl": function (v) {
                            return _vm.updateFormValue(
                              v,
                              "photo3",
                              _vm.form.storeInfo
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "InfoItem",
            {
              class: "container-item _scroll_item",
              attrs: {
                title: "5." + _vm.$t("storeVisitReport.common.storeMS"),
                "default-open": false,
              },
              on: { slider: _vm.onScollChange },
            },
            [
              _c(
                "div",
                { staticClass: "formStyle1" },
                [
                  _c(
                    "el-form-item",
                    {
                      key: "siTire_" + (_vm.isBailianFlag ? "by" : ""),
                      staticClass: "project-form-item",
                      attrs: {
                        label: _vm.$t("storeVisitReport.common.project"),
                        prop: "storeInfo.siTire",
                        rules: {
                          required: true,
                          validator: _vm.validateProject,
                          trigger: ["change", "blur"],
                        },
                      },
                    },
                    [
                      _c("p", [
                        _vm._v(_vm._s(_vm.$t("storeVisitReport.storeMS.tire"))),
                      ]),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          disabled: !_vm.canEdit,
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t("storeVisitReport.storeMS.siBalance"),
                        },
                        model: {
                          value: _vm.form.storeInfo.siBalance,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.storeInfo, "siBalance", $$v)
                          },
                          expression: "form.storeInfo.siBalance",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          disabled: !_vm.canEdit,
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t(
                            "storeVisitReport.storeMS.siWheelPosition"
                          ),
                        },
                        model: {
                          value: _vm.form.storeInfo.siWheelPosition,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.storeInfo, "siWheelPosition", $$v)
                          },
                          expression: "form.storeInfo.siWheelPosition",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          disabled: !_vm.canEdit,
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t(
                            "storeVisitReport.storeMS.siTireRepair"
                          ),
                        },
                        model: {
                          value: _vm.form.storeInfo.siTireRepair,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.storeInfo, "siTireRepair", $$v)
                          },
                          expression: "form.storeInfo.siTireRepair",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          disabled: !_vm.canEdit,
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t("storeVisitReport.storeMS.siValve"),
                        },
                        model: {
                          value: _vm.form.storeInfo.siValve,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.storeInfo, "siValve", $$v)
                          },
                          expression: "form.storeInfo.siValve",
                        },
                      }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.$t("storeVisitReport.storeMS.nonTire"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          disabled: !_vm.canEdit,
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t("storeVisitReport.storeMS.siEngineOil"),
                        },
                        model: {
                          value: _vm.form.storeInfo.siEngineOil,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.storeInfo, "siEngineOil", $$v)
                          },
                          expression: "form.storeInfo.siEngineOil",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          disabled: !_vm.canEdit,
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t("storeVisitReport.storeMS.siBrake"),
                        },
                        model: {
                          value: _vm.form.storeInfo.siBrake,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.storeInfo, "siBrake", $$v)
                          },
                          expression: "form.storeInfo.siBrake",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          disabled: !_vm.canEdit,
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t(
                            "storeVisitReport.storeMS.siFacialClean"
                          ),
                        },
                        model: {
                          value: _vm.form.storeInfo.siFacialClean,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.storeInfo, "siFacialClean", $$v)
                          },
                          expression: "form.storeInfo.siFacialClean",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          disabled: !_vm.canEdit,
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t(
                            "storeVisitReport.storeMS.siPerishableGoods"
                          ),
                        },
                        model: {
                          value: _vm.form.storeInfo.siPerishableGoods,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form.storeInfo,
                              "siPerishableGoods",
                              $$v
                            )
                          },
                          expression: "form.storeInfo.siPerishableGoods",
                        },
                      }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("storeVisitReport.storeMS.otherService")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("FormInput", {
                        attrs: {
                          val: _vm.form.storeInfo.siOther,
                          maxlength: 10,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "siOther",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "formStyle1" },
                [
                  _c(
                    "el-form-item",
                    {
                      key: "siMain_" + (_vm.isBailianFlag ? "by" : ""),
                      attrs: {
                        label: _vm.$t("storeVisitReport.storeSInfo.siMain"),
                        prop: "storeInfo.siMain",
                        rules: _vm.rules.chooseEmpty,
                      },
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          val: _vm.form.storeInfo.siMain,
                          options: _vm.optConfig.mainserviceOptions,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "siMain",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      key:
                        "siMainPercentage_" + (_vm.isBailianFlag ? "by" : ""),
                      attrs: {
                        label: _vm.$t(
                          "storeVisitReport.storeSInfo.siMainPercentage"
                        ),
                        prop: "storeInfo.siMainPercentage",
                        rules: _vm.rules.iptEmpty,
                      },
                    },
                    [
                      _c(
                        "FormInputNumber",
                        {
                          attrs: {
                            val: _vm.form.storeInfo.siMainPercentage,
                            max: 100,
                            step: 0.01,
                            mode: _vm.mode,
                          },
                          on: {
                            "update:val": function ($event) {
                              return _vm.$set(
                                _vm.form.storeInfo,
                                "siMainPercentage",
                                $event
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "append" }, slot: "append" },
                            [_vm._v("%")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "InfoItem",
            {
              class: "container-item _scroll_item",
              attrs: {
                title: "6." + _vm.$t("storeVisitReport.common.facAEq"),
                "default-open": false,
              },
              on: { slider: _vm.onScollChange },
            },
            [
              _c(
                "div",
                { staticClass: "form-checkbox-group" },
                [
                  _c(
                    "el-form-item",
                    {
                      key: "laundry_" + (_vm.isBailianFlag ? "by" : ""),
                      attrs: {
                        label: _vm.$t("storeVisitReport.facAEq.instoreFac"),
                        prop: "storeInfo.laundry",
                        rules: {
                          required: true,
                          validator: _vm.validateInstoreFac,
                          trigger: "change",
                        },
                      },
                    },
                    [
                      _c("el-checkbox", {
                        attrs: {
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t("storeVisitReport.facAEq.toilet"),
                          disabled: !_vm.canEdit,
                        },
                        model: {
                          value: _vm.form.storeInfo.laundry,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.storeInfo, "laundry", $$v)
                          },
                          expression: "form.storeInfo.laundry",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t(
                            "storeVisitReport.facAEq.customerLounge"
                          ),
                          disabled: !_vm.canEdit,
                        },
                        model: {
                          value: _vm.form.storeInfo.restRoom,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.storeInfo, "restRoom", $$v)
                          },
                          expression: "form.storeInfo.restRoom",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t(
                            "storeVisitReport.facAEq.wheelAlignment"
                          ),
                          disabled: !_vm.canEdit,
                        },
                        model: {
                          value: _vm.form.storeInfo.alignment,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.storeInfo, "alignment", $$v)
                          },
                          expression: "form.storeInfo.alignment",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t("storeVisitReport.facAEq.tireMachine"),
                          disabled: !_vm.canEdit,
                        },
                        model: {
                          value: _vm.form.storeInfo.fitting,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.storeInfo, "fitting", $$v)
                          },
                          expression: "form.storeInfo.fitting",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t("storeVisitReport.facAEq.DBMachine"),
                          disabled: !_vm.canEdit,
                        },
                        model: {
                          value: _vm.form.storeInfo.balancing,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.storeInfo, "balancing", $$v)
                          },
                          expression: "form.storeInfo.balancing",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-checkbox", {
                        attrs: {
                          "true-label": "Y",
                          "false-label": "N",
                          label: _vm.$t("storeVisitReport.facAEq.liftMachine"),
                          disabled: !_vm.canEdit,
                        },
                        model: {
                          value: _vm.form.storeInfo.liftingMachine,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.storeInfo, "liftingMachine", $$v)
                          },
                          expression: "form.storeInfo.liftingMachine",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "formStyle1" },
                [
                  _c(
                    "el-form-item",
                    {
                      key: "area_" + (_vm.isBailianFlag ? "by" : ""),
                      attrs: {
                        label: _vm.$t("storeVisitReport.facAEq.area"),
                        prop: "storeInfo.area",
                        rules: _vm.isBailianFlag ? _vm.rules.iptEmpty : null,
                      },
                    },
                    [
                      _c(
                        "FormInputNumber",
                        {
                          attrs: {
                            val: _vm.form.storeInfo.area,
                            step: 0.01,
                            mode: _vm.mode,
                          },
                          on: {
                            "update:val": function ($event) {
                              return _vm.$set(
                                _vm.form.storeInfo,
                                "area",
                                $event
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "append" }, slot: "append" },
                            [_vm._v("㎡")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      key: "workingBay_" + (_vm.isBailianFlag ? "by" : ""),
                      attrs: {
                        label: _vm.$t("storeVisitReport.facAEq.stationsCount"),
                        prop: "storeInfo.workingBay",
                        rules: _vm.rules.iptEmpty,
                      },
                    },
                    [
                      _c("FormInputNumber", {
                        attrs: {
                          val: _vm.form.storeInfo.workingBay,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "workingBay",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      key:
                        "accountingMethod_" + (_vm.isBailianFlag ? "by" : ""),
                      attrs: {
                        label: _vm.$t(
                          "storeVisitReport.facAEq.accountingMethod"
                        ),
                        prop: "storeInfo.accountingMethod",
                        rules: _vm.isBailianFlag ? _vm.rules.chooseEmpty : null,
                      },
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          val: _vm.form.storeInfo.accountingMethod,
                          options: _vm.optConfig.daMethodOptions,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.storeInfo,
                              "accountingMethod",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "InfoItem",
            {
              class: "container-item _scroll_item",
              attrs: {
                title: "7." + _vm.$t("storeVisitReport.common.otherMsg"),
                "default-open": false,
              },
              on: { slider: _vm.onScollChange },
            },
            [
              _c(
                "div",
                { staticClass: "formStyle1" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "u-iptItem",
                      attrs: {
                        label: _vm.$t(
                          "storeVisitReport.otherMsg.visitFrequency"
                        ),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.info.storeInfo.visitFrequency,
                          disabled: "",
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.info.storeInfo,
                              "visitFrequency",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "u-iptItem",
                      attrs: {
                        label: _vm.$t(
                          "storeVisitReport.otherMsg.lastPurchaseTime"
                        ),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.info.storeInfo.lastPurchaseTime,
                          disabled: "",
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.info.storeInfo,
                              "lastPurchaseTime",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "u-iptItem",
                      attrs: {
                        label: _vm.$t("storeVisitReport.otherMsg.pointBalance"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.info.storeInfo.pointBalance,
                          disabled: "",
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.info.storeInfo,
                              "pointBalance",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "u-iptItem",
                      attrs: {
                        label: _vm.$t(
                          "storeVisitReport.otherMsg.rebateBalance"
                        ),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.info.storeInfo.rebateBalance,
                          disabled: "",
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.info.storeInfo,
                              "rebateBalance",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "u-iptItem",
                      attrs: {
                        label: _vm.$t(
                          "storeVisitReport.otherMsg.lastVisitTime"
                        ),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.info.storeInfo.lastStartTime,
                          disabled: "",
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.info.storeInfo,
                              "lastStartTime",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "u-iptItem",
                      attrs: {
                        label: _vm.$t("storeVisitReport.otherMsg.contractTM"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.info.storeInfo.rtlTmallFlag,
                          disabled: "",
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.info.storeInfo,
                              "rtlTmallFlag",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "u-iptItem",
                      attrs: {
                        label: _vm.$t("storeVisitReport.otherMsg.contractJD"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.info.storeInfo.rtlJdFlag,
                          disabled: "",
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.info.storeInfo,
                              "rtlJdFlag",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }